import Vue from 'vue'
import iView from 'iview'
import locale from 'iview/dist/locale/en-US'

import '../iview-variables.less'

Vue.use(iView, { locale })
